import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import AccountEmail from './AccountEmail';
import KazooLoginForm from '../common/KazooLoginForm';
import { makeKazooRequest } from '../common/KazooUtil';
import { Button, Divider, Input, Switch } from 'antd';
import 'antd/dist/antd.css';

export default class AccountDump extends Component {
  static propTypes = {
    service: PropTypes.string.isRequired,
  };

  state = {
    authToken: '',
    ivr: false,
    byo: false,
    selfInstall: false,
  };

  dumpAccount = (accountId) => {
    const { authToken } = this.state;
    this.setState({ loading: true, ivr: false });
    const endpoints = [
      '',
      '/users?paginate=false',
      '/callflows?paginate=false',
      '/vmboxes?paginate=false',
      '/devices?paginate=false',
      '/menus?paginate=false',
    ];
    const accountData = {};
    let account, users, callflows, vmboxes, devices, menus;
    Promise.all(endpoints.map(endpoint => makeKazooRequest(this.props.service, authToken, accountId, endpoint)))
      .then(resp => {
        [ account, users, callflows, vmboxes, devices, menus ] = resp;
        const mainline = callflows.find(callflow => callflow.type === 'main' && callflow.name);
        if (mainline) {
          accountData.mainline = mainline.numbers.pop();
        }
        accountData.name = account.name;
        accountData.realm = account.realm;
      }).then(() =>
        Promise.all(users.map(user => this.processUser(accountId, user, callflows, vmboxes)))
          .then(usersTable => accountData.users = usersTable))
      .then(() =>
        Promise.all(devices.map(device => this.processDevice(accountId, device, users)))
          .then(devicesTable => accountData.devices = devicesTable))
      .then(() =>
        Promise.all(menus.map(menu => this.processMenu(accountId, menu)))
          .then(menusTable => accountData.menus = menusTable)
      )
      .then(() => this.setState({ accountData, loading: false }))
      .catch(() => {
        this.setState({ loading: false });
        this.loggedIn(); // Log out on failed requests
      });
  };

  copyHTML = () => {
    const htmlString = ReactDOMServer.renderToString(
      <AccountEmail
        accountData={ this.state.accountData }
        ivr={ this.state.ivr }
        byo={ this.state.byo }
        selfInstall={ this.state.selfInstall } >
      </AccountEmail>
    ).split(' class=""').join('');
    navigator.clipboard.writeText(htmlString);
  };

  toggleState = (param) => (e) => {
    this.setState({ [param]: !this.state[param] });
  };

  processUser = async (accountId, user, callflows, vmboxes) => {
    const { authToken } = this.state;
    const userData = {
      key: user.id,
      extension: user.presence_id,
      name: `${user.first_name} ${user.last_name}`,
      email: user.email,
    };
    const ddi = callflows.find(callflow => callflow.owner_id === user.id);
    if (ddi) {
      userData.ddi = ddi.numbers.pop();
    }
    let vmbox = vmboxes.find(vmbox => vmbox.owner_id === user.id);
    if (vmbox) {
      vmbox = await makeKazooRequest(this.props.service, authToken, accountId, `/vmboxes/${vmbox.id}`);
      userData.vmNum = vmbox.mailbox;
    }
    return userData;
  };

  processDevice = async (accountId, device, users) => {
    const { authToken } = this.state;
    device = await makeKazooRequest(this.props.service, authToken, accountId, `/devices/${device.id}`);
    const deviceData = {
      key: device.id,
      deviceType: device.device_type,
      deviceName: device.name,
      deviceMac: device.mac_address,
      sipUsername: device.sip.username,
      sipPassword: device.sip.password,
    };
    if (deviceData.deviceMac) {
      deviceData.deviceMac = deviceData.deviceMac.toUpperCase();
    }
    if (device.owner_id) {
      const user = users.find(user => user.id === device.owner_id);
      if (user) {
        deviceData.userName = `${user.first_name} ${user.last_name}`;
      }
    }
    return deviceData;
  };

  processMenu = async (accountId, menu) => {
    const { authToken } = this.state;
    menu = await makeKazooRequest(this.props.service, authToken, accountId, `/menus/${menu.id}`);
    const menuData = {
      key: menu.id,
      menuName: menu.name,
      recordPin: menu.record_pin,
    };
    return menuData;
  };

  loggedIn = (authToken, authAccountId) => {
    localStorage.setItem(this.props.service + '_auth_token', authToken || '');
    localStorage.setItem(this.props.service + '_account_id', authAccountId || '');
    this.setState({ authToken });
  };

  componentDidMount() {
    if (localStorage.getItem(this.props.service + '_auth_token') && localStorage.getItem(this.props.service + '_account_id')) {
      this.loggedIn(localStorage.getItem(this.props.service + '_auth_token'), localStorage.getItem(this.props.service + '_account_id'));
    }
  }

  render() {
    const { accountData, authToken, byo, loading, selfInstall, ivr } = this.state;
    const authDisplayed = !loading && !authToken;
    const dataDisplayed = !loading && accountData;
    return (
      <div style={{ background: '#ECECEC', padding: '30px' }}>
        { authDisplayed && <KazooLoginForm loggedIn={ this.loggedIn } service={this.props.service}/> }
        { !authDisplayed &&
          (<div>
            <Input.Search
              placeholder='Enter account ID'
              onSearch={ this.dumpAccount }
              disabled={ loading }
              style={{ marginBottom: '10px' }}>
            </Input.Search>
            <span>Self Install? </span>
            <Switch
              checked={ selfInstall }
              loading={ loading }
              onChange= { this.toggleState('selfInstall') }
            />
            <span style={{ marginLeft: '10px' }}>BYO Hardware? </span>
            <Switch
              checked={ byo && selfInstall }
              loading={ loading }
              disabled={ !selfInstall }
              onChange= { this.toggleState('byo') }
            />
            { accountData && accountData.menus.length > 0 &&
              (
                <span style={{ marginLeft: '10px' }}>DIY IVR?
                  <Switch
                    checked={ ivr }
                    loading={ loading }
                    onChange= { this.toggleState('ivr') }
                  />
                </span>
              )
            }
            { dataDisplayed &&
              <Button onClick={ this.copyHTML } style={{ marginLeft: '10px' }}>Copy HTML</Button>
            }
          </div>)
        }
        { dataDisplayed &&
          (<div>
            <Divider></Divider>
            <AccountEmail
              accountData={ accountData }
              ivr={ ivr }
              byo={ byo }
              selfInstall={ selfInstall } >
            </AccountEmail>
          </div>)
        }
      </div>
    );
  }
}
